import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const LINKS = [
  { label: "About", href: "#about" },
  { label: "The Work", href: "#work" },
  { label: "Current Slate", href: "#slate" },
  { label: "Contact", href: "#contact" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (e, href) => {
    e.preventDefault();
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled ? "backdrop-blur-md bg-[rgba(244,244,247,0.7)] border-b border-[#DCDEE6]" : "border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <a
          href="#top"
          onClick={(e) => go(e, "#top")}
          data-testid="nav-logo"
          className="font-serif text-2xl md:text-3xl tracking-wide text-onyx"
        >
          Onyx <span className="text-ochre">&amp;</span> Ochre
        </a>
        <nav className="hidden md:flex items-center gap-10">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => go(e, l.href)}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="link-underline font-sans uppercase text-xs tracking-[0.2em] text-onyx-muted hover:text-onyx"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <a
          href="#contact"
          onClick={(e) => go(e, "#contact")}
          data-testid="nav-cta"
          className="hidden md:inline-block font-sans uppercase text-xs tracking-[0.2em] border border-onyx px-5 py-2 hover:bg-onyx hover:text-alabaster transition-colors duration-300"
        >
          Enquire
        </a>
        <Link
          to="/admin/login"
          data-testid="nav-admin"
          className="md:hidden font-mono text-xs text-onyx-muted"
        >
          Menu
        </Link>
      </div>
    </header>
  );
}
